module.exports = "<p>\r\n  verification works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/verification/verification.component.html
// module id = ../../../../../src/app/verification/verification.component.html
// module chunks = main